/* VOLT vt-motion.js — reveals, parallax, count-up, tabs, scroller.
   Transform/opacity only. Honors prefers-reduced-motion. Re-inits on section load. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = root.querySelectorAll('[data-vt-reveal]:not(.vt-in)');
    if (!els.length) return;
    if (RM || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vt-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vt-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCounters(root) {
    var els = root.querySelectorAll('[data-vt-count]:not([data-vt-counted])');
    if (!els.length) return;
    var run = function (el) {
      el.setAttribute('data-vt-counted', '1');
      var target = parseFloat(el.getAttribute('data-vt-count'));
      if (isNaN(target) || RM) { return; }
      var dur = 1100, t0 = null, isInt = target % 1 === 0;
      var startText = el.textContent;
      function frame(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var v = target * eased;
        el.textContent = isInt ? Math.round(v) : v.toFixed(1);
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax(root) {
    if (RM) return;
    var els = [].slice.call(root.querySelectorAll('[data-vt-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var f = parseFloat(el.getAttribute('data-vt-parallax')) || 0.1;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translateY(' + (mid * -f).toFixed(1) + 'px) scale(' + (1 + f * 0.6) + ')';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function initTabs(root) {
    root.querySelectorAll('[data-vt-tabs]:not([data-vt-ready])').forEach(function (w) {
      w.setAttribute('data-vt-ready', '1');
      var btns = [].slice.call(w.querySelectorAll('.vt-tab-btn'));
      var panels = [].slice.call(w.querySelectorAll('.vt-tabs__panel'));
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('vt-tab--on'); b.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('vt-panel--on'); });
          btn.classList.add('vt-tab--on');
          btn.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('vt-panel--on');
        });
      });
    });
  }

  function initScrollers(root) {
    root.querySelectorAll('[data-vt-scroller]:not([data-vt-ready])').forEach(function (w) {
      w.setAttribute('data-vt-ready', '1');
      var track = w.querySelector('.vt-scroller__track');
      var prev = w.querySelector('[data-vt-prev]');
      var next = w.querySelector('[data-vt-next]');
      var dotsWrap = w.querySelector('.vt-scroller__dots');
      var cards = [].slice.call(w.querySelectorAll('.vt-scene'));
      if (!track || !cards.length) return;
      function step() { return cards[0].getBoundingClientRect().width + 20; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: RM ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: RM ? 'auto' : 'smooth' }); });
      /* Dots = reachable scroll pages, not cards — one dot per card lied about
         how many positions exist (client r1). Rebuilt on resize; hidden if 1 page. */
      var dots = [];
      function pageCount() {
        var max = track.scrollWidth - track.clientWidth;
        if (max < 10) return 1;
        return Math.round(max / step()) + 1;
      }
      function buildDots() {
        if (!dotsWrap) return;
        var n = pageCount();
        if (dots.length === n) return;
        dotsWrap.innerHTML = '';
        dots = [];
        dotsWrap.style.display = n <= 1 ? 'none' : '';
        for (var i = 0; i < n; i++) {
          (function (i) {
            var d = document.createElement('button');
            d.className = 'vt-dot';
            d.type = 'button';
            d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            d.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: RM ? 'auto' : 'smooth' }); });
            dotsWrap.appendChild(d);
            dots.push(d);
          })(i);
        }
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        var i = track.scrollLeft >= max - 10 ? dots.length - 1 : Math.round(track.scrollLeft / step());
        i = Math.max(0, Math.min(i, dots.length - 1));
        dots.forEach(function (d, j) { d.classList.toggle('vt-dot--on', j === i); });
        if (prev) prev.toggleAttribute('disabled', track.scrollLeft < 10);
        if (next) next.toggleAttribute('disabled', track.scrollLeft > max - 10);
      }
      buildDots();
      var vtResizeT;
      window.addEventListener('resize', function () {
        clearTimeout(vtResizeT);
        vtResizeT = setTimeout(function () { buildDots(); sync(); }, 150);
      });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      sync();
    });
  }

  function init(root) {
    root = root || document;
    initReveals(root);
    initCounters(root);
    initParallax(root);
    initTabs(root);
    initScrollers(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
